import React, { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  Visibility,
  CheckCircleOutline,
  CancelOutlined,
  AccessTime,
} from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import SearchBar from "../../components/SearchBar";
import Pagination from "../../components/Pagination";
import Loader from "../../helpers/Loader";
import { BOOKING_STATUS } from "../../helpers/constants/enums";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useLazyGetAllClassBookingQuery } from "../../services/booking";

type Booking = {
  _id: string;
  bookingNumber: string;
  parents: {
    name: string;
    email: string;
  };
  tutors: {
    name: string;
    email: string;
  };
  subjectspecializations?: {
    _id: string;
    name: string;
  }[];
  bookingdetails: {
    _id: string;
    date: string;
    classStart: string;
    classEnd: string;
  }[];
  attendance?: {
    sessionId: string;
    attended: boolean;
    joinTime: number;
    leaveTime: number;
    participationScore: number;
    questionsAsked: number;
  }[];
};

const Bookings = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const { _id } = useParams();
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(10); // Set to match dummy data length
  const [rows, setRows] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [fetchBooking] = useLazyGetAllClassBookingQuery();

  const fetchData = async (page: number, search: string) => {
    setLoading(true);
    try {
      const response = await fetchBooking({
        page,
        search,
        // bookingType: BOOKING_STATUS.PAST,
        classId: _id,
      }).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        setRows(response?.data?.booking);
        setTotalCount(response?.data?.totalBooking);
      } else {
        setRows([]);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  useEffect(() => {
    fetchData(page, debouncedSearchTerm);
  }, [page, debouncedSearchTerm]);

  return (
    <div>
      <Loader isLoad={loading} />

      <Box className="cards_header">
        {/* <SearchBar
          value={searchTerm}
          searchTerm={searchTerm}
          onCross={() => setSearchTerm("")}
          setDebouncedSearchTerm={setDebouncedSearchTerm}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setSearchTerm(e.target.value)
          }
        /> */}
      </Box>

      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center">S.No</TableCell>
              <TableCell align="center">Booking No</TableCell>
              <TableCell align="center">Parent</TableCell>
              <TableCell align="center">Invoice No</TableCell>
              <TableCell align="center">Total Fee</TableCell>
              <TableCell align="center">Service Charges</TableCell>
              <TableCell align="center">Tutor Money</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {!loading && rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  <Typography variant="body1" color="textSecondary">
                    No Booking found
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              rows.map((row: any, index: number) => (
                <TableRow key={row?._id}>
                  <TableCell align="center">
                    {(page - 1) * 10 + index + 1}
                  </TableCell>
                  <TableCell align="center">{row?.bookingNumber}</TableCell>
                  <TableCell>
                    <p style={{ margin: 0 }}>{row?.parent?.name}</p>
                    <p style={{ margin: 0, fontSize: "0.8rem", color: "#666" }}>
                      {row?.parent?.email}
                    </p>
                  </TableCell>
                  <TableCell align="center">{row?.invoiceNo}</TableCell>
                  <TableCell align="center">{row?.grandTotal}</TableCell>
                  <TableCell align="center">{row?.serviceCharges}</TableCell>
                  <TableCell align="center">{row?.tutorMoney}</TableCell>
                  <TableCell>
                    <Box className="table_actions">
                      <IconButton
                        onClick={() =>
                          navigate(`/class-booking/details/${row?._id}`, {
                            state: { userStatus: "PENDING" },
                          })
                        }
                      >
                        <VisibilityIcon />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {rows.length > 0 && (
        <Pagination
          setPage={setPage}
          module={rows}
          page={page}
          onPageChange={(newPage) => setPage(newPage)}
          totalPages={Math.ceil(totalCount / 10)}
        />
      )}
    </div>
  );
};

export default Bookings;
